import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useSizeConversionTables = defineStore('size-conversion-tables', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.sizeConversionTable_ListSizeConversionTables,
    dto: 'SizeConversionTableDto',
    create: api.sizeConversionTable_CreateSizeConversionTable,
    delete: api.sizeConversionTable_DeleteSizeConversionTable,
    signalR: '',
  });

  return {
    ...globalStoreBase,
  };
});
